import React, { useEffect } from "react";
import styles from "./index.module.css";
import { Tag } from "../../assets";

const Glow = (props) => {
  useEffect(() => {
    console.log(props);
  }, []);

  return (
    <div style={{top: props.width < 900 ? '50px' : '150px'}} className={`z-10 absolute left-[50px]`}>
      <div className={`${styles.glow}`}></div>
      <div className={`${styles.particles}`}>
       <Tag className="top-[20px] left-[20px] relative" />
        <div className={`${styles.rotate}`}>
          <div className={`${styles.angle}`}>
            <div className={`${styles.size}`}>
              <div className={`${styles.position}`}>
                <div className={`${styles.pulse}`}>
                  <div className={`${styles.particle}`}></div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.angle}`}>
            <div className={`${styles.size}`}>
              <div className={`${styles.position}`}>
                <div className={`${styles.pulse}`}>
                  <div className={`${styles.particle}`}></div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.angle}`}>
            <div className={`${styles.size}`}>
              <div className={`${styles.position}`}>
                <div className={`${styles.pulse}`}>
                  <div className={`${styles.particle}`}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Glow;
